import React from 'react'
import { PageHeader, FlexContainer, Tile, Loader } from '@reapit/elements'

const SaveToCrm: React.FC = () => {
  return (
    <div className='basicUpdate'>
        <h1>Saving details to CRM</h1>
        <p>We are currently saving your details to your CRM</p>
        <p className='loader'><Loader style={{ width: '100%', height: '5px' }} /></p>
    </div>
  )
}

export default SaveToCrm
